import type {AiChatStateContextType} from '@/ai-chat/providers/ai-chat-provider.types';
import type {DecisionsAssist, RequestConfig} from '@Components/ai-chat-window/ai-chat-window.types';

/** Only a super user sends their decisions switch; everyone else sends nothing and gets the environment's setting. */
export const getDecisionsAssistToSend = (state: AiChatStateContextType | undefined): DecisionsAssist | null => {
  if (!state?.isSuperUser) {
    return null;
  }

  return state.decisionsAssist;
};

export const withDecisionsAssist = (requestConfig: RequestConfig | undefined, decisionsAssist: DecisionsAssist | null): RequestConfig | undefined => {
  if (decisionsAssist === null) {
    return requestConfig;
  }

  return {...requestConfig, preferences: {...requestConfig?.preferences, decisionsAssist}};
};
